export const SET_IS_AUTH = "SET_IS_AUTH";
export const SET_TOKEN = "SET_TOKEN";
export const LOGOUT = "LOGOUT";
export const FETCH_USER_LOADING = "FETCH_USER_LOADING";
export const FETCH_USER = "FETCH_USER";
export const HANDLE_EDIT_PROFILE = "HANDLE_EDIT_PROFILE";
export const SET_TEMP_EMAIL = "SET_TEMP_EMAIL";
